export default __webpack_public_path__ + "static/media/quest-diagonostic-logo.512c7def.png";